import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeProvider';

interface ThemeToggleProps {
  collapsed?: boolean;
  compact?: boolean;
  className?: string;
}

export function ThemeToggle({ collapsed = false, compact = false, className = '' }: ThemeToggleProps) {
  const { theme, setTheme, toggleTheme, isLight } = useTheme();

  if (compact) {
    return (
      <button
        type="button"
        onClick={toggleTheme}
        aria-label={isLight ? 'Переключить на тёмную тему' : 'Переключить на светлую тему'}
        title={isLight ? 'Переключить на тёмную тему' : 'Переключить на светлую тему'}
        className={`flex h-9 w-9 items-center justify-center rounded-lg border border-surface-border bg-surface-overlay text-slate-300 hover:text-slate-100 transition ${className}`}
      >
        {isLight ? (
          <Sun size={17} className="text-amber-500" />
        ) : (
          <Moon size={17} className="text-accent" />
        )}
      </button>
    );
  }

  if (collapsed) {
    return (
      <button
        type="button"
        onClick={toggleTheme}
        aria-label={isLight ? 'Включить тёмную тему' : 'Включить светлую тему'}
        title={isLight ? 'Светлая тема (нажмите для переключения на тёмную)' : 'Тёмная тема (нажмите для переключения на светлую)'}
        className={`flex w-full items-center justify-center rounded-lg py-2.5 text-slate-400 transition hover:bg-white/5 hover:text-slate-100 ${className}`}
      >
        {isLight ? (
          <Sun size={17} className="text-amber-500 transition-transform hover:rotate-45" />
        ) : (
          <Moon size={17} className="text-accent transition-transform hover:-rotate-12" />
        )}
      </button>
    );
  }

  return (
    <div
      className={`inline-flex w-full items-center rounded-xl border border-surface-border bg-surface-overlay p-0.5 text-xs ${className}`}
      role="group"
      aria-label="Выбор темы оформления"
    >
      <button
        type="button"
        onClick={() => setTheme('light')}
        aria-pressed={isLight}
        className={`flex flex-1 items-center justify-center gap-1.5 rounded-lg py-1.5 font-medium transition-all ${
          isLight
            ? 'bg-surface-raised font-semibold text-slate-100 shadow-sm border border-surface-border/80'
            : 'text-slate-400 hover:text-slate-200'
        }`}
      >
        <Sun size={14} className={isLight ? 'text-amber-500' : 'text-slate-400'} />
        <span>Светлая</span>
      </button>

      <button
        type="button"
        onClick={() => setTheme('dark')}
        aria-pressed={!isLight}
        className={`flex flex-1 items-center justify-center gap-1.5 rounded-lg py-1.5 font-medium transition-all ${
          !isLight
            ? 'bg-surface-raised font-semibold text-slate-100 shadow-sm border border-surface-border/80'
            : 'text-slate-400 hover:text-slate-200'
        }`}
      >
        <Moon size={14} className={!isLight ? 'text-accent' : 'text-slate-400'} />
        <span>Тёмная</span>
      </button>
    </div>
  );
}
